/* global $ */
import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const setSlickNav = async () => {
  $('#menu').slicknav({
    closedSymbol: '<span class="closed">+</span>',
    openedSymbol: '<span class="opened">-</div>',
    closeOnClick: true,
    appendTo: '#mobile-menu-container',
    showChildren: true
  })

  /* let logo = document.querySelector('.logo') // Get logo
  if (logo) { // Add logo
    let slickNavElem = document.querySelector('.slicknav_menu')
    let logoElem = document.createElement('div')
    logoElem.className = 'slicknav_menu__logo'
    logoElem.innerHTML = logo.innerHTML
    slickNavElem.appendChild(logoElem)
    return slickNavElem
  } */
}

const setTranslations = async () => {
  
  /* let langs = document.querySelector('.langs')
  if (langs) {
    let slickNavElem = document.querySelector('.slicknav_nav')
    let langsElem = document.createElement('div')
    langsElem.className = 'slicknav_langs'
    langsElem.innerHTML = langs.innerHTML
    slickNavElem.appendChild(langsElem)
    return slickNavElem
  } */
}

const setCloseOnOutsideClick = () => {
  $(document).off('click.lucciSlicknavOutside touchend.lucciSlicknavOutside')
  $(document).on('click.lucciSlicknavOutside touchend.lucciSlicknavOutside', (event) => {
    const isOpen = $('#mobile-menu-container .slicknav_nav:visible').length > 0
    if (!isOpen) return

    const clickedInsideMenu = $(event.target).closest('#mobile-menu-container .slicknav_menu').length > 0
    if (!clickedInsideMenu) {
      $('#mobile-menu-container .slicknav_btn').trigger('click')
    }
  })
}

const setHeadroom = (slickNavElem) => {
  if (slickNavElem) {
    const headroom = new Headroom(slickNavElem, {
      offset: 50,
      tolerance: 5,
      classes: {
        // When element is initialised
        initial: 'headroom--mobile',
        // When scrolling up
        pinned: 'headroom--pinned--mobile',
        // When scrolling down
        unpinned: 'headroom--unpinned--mobile'
      },
      // Cancel unpin when Slick nav is open
      onUnpin: function () {
        if ($('.slicknav_open')[0]) this.pin()
      }
    })
    headroom.init()
  }
}

const init = async () => {
  await setSlickNav().then(setHeadroom).then(setTranslations) // Initialize SlickNav, then set headroom
  setCloseOnOutsideClick()
}

export default {
  init
}
